import Handler from "../Handler";

class LockedBetsLobbyHandler extends Handler {
  execute(message) {
    let parsedData = JSON.parse(message);
    this.service.processLockedBets(parsedData);
  }
}

export default LockedBetsLobbyHandler;
